export default "__VITE_ASSET__DYWW5yEm__"